module.exports = __webpack_public_path__ + "static/media/react.1ff63cc5.png";